<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f002-01.jpg" width="80%"/></p>
<p class="caption">The Normans enlarged the Anglo-Scandinavian church by creating arches through the original external walls in order to create aisles. The side-alternate arrangement of the quoins and the blocked feature above the Norman arches provide evidence of a pre-Conquest building.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_chapter011.vue?482be00c